

//Data imports
import AccessMatrix from '@/router/access-matrix';

const DashboardRedirectContainer = () => import('@/views/dashboard/DashboardRedirectContainer.vue')
const DashboardHome = () => import('@/views/dashboard/DashboardHome.vue')
const TimeReport = () => import('@/views/dashboard/TimeReport.vue')
const OpenOrders = () => import('@/views/dashboard/OpenOrders.vue')
const ExportMachines = () => import('@/views/dashboard/ExportMachines.vue')

//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.DashboardTrunk.module,
    display: { key: "servicesystem.pages.page_titles.dashboard" },
    icon: "mdi-chart-box",
  },
  //redirect: { name: "DashboardHome" }, //handled in component instead to account for usertype
  path: '/dashboard',
  name: 'Dashboard',
  component: DashboardRedirectContainer,
  children: [
    {
      meta: {
        authorize: AccessMatrix.DashboardTrunk.adminpages,
        display: { key: "servicesystem.pages.page_titles.dashboard" },
        icon: "mdi-chart-box",
      },
      path: 'DashboardHome',
      name: 'DashboardHome',
      component: DashboardHome,
    },
    {
      meta: {
        authorize: AccessMatrix.DashboardTrunk.adminpages,
        display: { key: "servicesystem.pages.page_titles.timereport" },
        icon: "mdi-clock",
        overrides: {
          header: {
            buttons: ['NewDialogTriggerBtn', 'ReportDateRangeSelector', 'ExportBtn'],
          },
        }
      },
      path: 'timereport',
      name: 'TimeReport',
      component: TimeReport,
    },
    {
      meta: {
        authorize: AccessMatrix.DashboardTrunk.adminpages,
        display: { key: "servicesystem.pages.page_titles.openorders" },
        icon: "mdi-triangle",
      },
      path: 'openorders',
      name: 'OpenOrders',
      component: OpenOrders,
    },
    {
      meta: {
        authorize: AccessMatrix.DashboardTrunk.adminpages,
        display:{ key: "servicesystem.pages.page_titles.machine_export" },
        icon: "$machine",
      },
      path: 'machine-export',
      name: 'ExportMachines',
      component: ExportMachines,
    },
  ]
};

export default trunk;